<template>
  <div class="basic_list_photos">
    <div class="tooptipPart module_edit_btn">
      <my_edit_btn :module="module"></my_edit_btn>
      <template v-if="$store.state.app.view_pattern === 'pc'">
        <my_edit_btn :module="module" tabName="animation"></my_edit_btn>
        <my_close_btn :module="module" :column="column" :moduleIndex="module_index"></my_close_btn>
      </template>
    </div>
    <my_title_index :title="infor.title"></my_title_index>
    <div class="list_frame" v-loading="loading">
      <!-- 第一种模式 -->
      <template v-if="module.data.listArr.module_style == '0'">
        <div class="list_box">
          <template v-for="(item,i) in imgs">
            <one_img
              :item="item"
              :i="i"
              :key="i"
              :pc_infor="pc_infor"
              :infor="infor"
              :imgs="imgs"
              :module="module"
            ></one_img>
          </template>
        </div>
        <my_page_index
          v-if="pc_infor.page.radioValue"
          :page="pc_infor.page"
          :currentPage.sync="currentPage"
          :total="total"
        ></my_page_index>
      </template>

      <!-- 轮播模式 -->
      <template v-if="module.data.listArr.module_style == '1'">
        <!-- pc模式 -->
        <template v-if="$store.state.app.view_pattern === 'pc'">
          <div class="banner_child">
            <swiper
              ref="mySwiper"
              class="basic_list_photos_swiper list_box"
              :options="swiperOption"
              v-if="$store.state.app.basic_list_photos_isRender"
            >
              <swiper-slide v-for="(item,i) in imgs" :key="i" class="slide-list">
                <one_img
                  :item="item"
                  :i="i"
                  :pc_infor="pc_infor"
                  :infor="infor"
                  type="swiper"
                  :imgs="imgs"
                  :module="module"
                ></one_img>
              </swiper-slide>
            </swiper>

            <template v-if="$store.state.app.view_pattern === 'pc'">
              <div class="arrow prev" @click="swiper_prev"></div>
              <div class="arrow next" @click="swiper_next"></div>
            </template>
          </div>
        </template>

        <template v-else>
          <div class="list_box swiper_list_box">
            <template v-for="(item,i) in imgs">
              <one_img
                :item="item"
                :key="i"
                :i="i"
                :pc_infor="pc_infor"
                :infor="infor"
                :imgs="imgs"
                :module="module"
              ></one_img>
            </template>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

import one_img from "./components/one_img";
import {editAtlasList} from "@/api/app.js";
import {
  create_data
} from '@/base/widgets_data_compatible';
import { box_shadow_style_add, getCommonStyle } from "@/base/widgets_data_compatible";
export default {
  name: "basic_list_photos",
  data() {
    return {
      imgs: [],
      loading: false,
      currentPage: 1,
      total: 0
    };
  },
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
  },
  methods: {
    swiper_prev() {
      this.$refs.mySwiper.swiper.slidePrev();
    },
    swiper_next() {
      this.$refs.mySwiper.swiper.slideNext();
    },
    page_reset() {
      this.currentPage = 1;
      this.total = 0;
    },
    banner_set_compatible() {
      const infor = this.module.data.pc_widgets_infor;
      const data = create_data();
      if (typeof infor.slides_group == 'undefined') {
        this.$set(infor, 'slides_group', data.slides_group);
        this.$set(infor, 'swiper_loop', data.swiper_loop);
        this.$set(infor, 'banner_set', data.banner_set);

      }
    }
  },
  watch: {
    "module.data.listArr": {
      handler: function (val, oldVal) {
        this.page_reset();
        this.templet.imgs_init(this);
      },
      deep: true
    },
    currentPage() {
      this.templet.imgs_init(this);
    },
    "pc_infor.page": {
      handler: function (val, oldVal) {
        this.page_reset();
        this.templet.imgs_init(this);
      },
      deep: true
    }
  },
  computed: {
    infor() {
      return this.module.data[
      this.$store.state.app.view_pattern + "_widgets_infor"
        ];
    },
    pc_infor() {
      return this.module.data.pc_widgets_infor;
    },
    swiperOption() {
      const infor = this.module.data.pc_widgets_infor;
      const num = parseInt(infor.col_num[infor.col_num.radio_val].value);
      const slidesPerGroup = parseInt(infor.slides_group[infor.slides_group.radio_val].value);
      const loop = infor.swiper_loop === 'true' ? true : false
      const obj = {
        myVm: this,
        loop: slidesPerGroup == 1 ? loop : false,
        direction: "horizontal",
        slidesPerView: num,
        slidesPerGroup,//每次翻页个数
        observer: true,
        observeParents: true,
      }
      const autoplay = this.templet.autoplay_obj(
        infor.banner_set,
        obj
      );
      obj.autoplay = autoplay;
      return obj;
    },

  },
  components: {
    one_img
  },
  created() {
    this.banner_set_compatible();
    this.templet.imgs_init(this);
    // 4.6.7 组合阴影
    if (typeof this.pc_infor.boxShadow == "undefined") {
      this.$set(this.pc_infor, "boxShadow", box_shadow_style_add().boxShadow);
    }
    // 圆角
    if (typeof this.pc_infor.borderRadius == "undefined") {
      this.$set(this.pc_infor, "borderRadius", getCommonStyle().borderRadius);
    }
  },
  mounted() {

  }
};
</script>

<style scoped lang="scss">
.basic_list_photos {
  .list_frame {
    width: 100%;

    .list_box {
      font-size: 0;
    }
  }
}

.pc_pattern {
  .list_frame {
    min-height: 50px;
  }

  .banner_child {
    padding: 0 60px;
    position: relative;
    .basic_list_photos_swiper{
      padding: 5px;
    }
    .arrow {
      cursor: pointer;
      display: block;
      width: 40px;
      height: 40px;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      border-radius: 50%;
      position: absolute;
      z-index: 99;
      top: 50%;
      -webkit-transform: translateY(-50%);
      -moz-transform: translateY(-50%);
      -ms-transform: translateY(-50%);
      -o-transform: translateY(-50%);
      transform: translateY(-50%);
      background: rgba(0, 0, 0, 0.2);
      -webkit-transition: background 0.15s;
      -o-transition: background 0.15s;
      -moz-transition: background 0.15s;
      transition: background 0.15s;
      outline: 0;
    }

    .arrow:before {
      content: "";
      position: absolute;
      display: block;
      width: 10px;
      height: 18px;
      background: url("/static/image/backimg1.png") -23px -268px;
      top: 50%;
      left: 50%;
      -webkit-transform: translate(-50%) translateY(-50%);
      -moz-transform: translate(-50%) translateY(-50%);
      -ms-transform: translate(-50%) translateY(-50%);
      -o-transform: translate(-50%) translateY(-50%);
      transform: translate(-50%) translateY(-50%);
    }

    .prev {
      left: 10px;
    }

    .next {
      right: 10px;
    }

    .next:before {
      background-position-x: -53px;
      left: 54%;
    }
  }
}

.mb_pattern {
  .list_one {
    padding: 1.89% !important;
    background: #fff;
  }

  .list_box {
    padding: 1.89% !important;
  }

  .list_frame {
    overflow: hidden;

    .swiper_list_box {
      position: relative;
      // bottom: -17px;
      white-space: nowrap;
      // overflow-x: auto;
      overflow: hidden;

      .list_one {
        width: 45% !important;
      }
    }

    .swiper_list_box::-webkit-scrollbar {
      height: 0px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_list_photos/index.vue